/** Campos da aba "Informações adicionais" — todos preenchidos = indicador completo (ex.: bolinha verde no Kanban). */
export const ADDITIONAL_INFO_FIELDS = [
  "situacao",
  "canal",
  "regiao",
  "campanha",
  "produto",
];

export const isContactAdditionalInfoComplete = (contact) => {
  if (!contact) return false;
  return ADDITIONAL_INFO_FIELDS.every((field) => {
    const v = contact[field];
    if (v === null || v === undefined) return false;
    return String(v).trim() !== "";
  });
};
